import { isNumber } from "./is-number";

export const isFiniteNumber = (value: any): value is number => {
  return isNumber(value) && Number.isFinite(value);
};
